<template>
    <landlords-find
        :params="{
            landlord: $route.params.landlord
        }"
        :include="[
            'account'
        ]"
    >
        <div
            slot-scope="{
                data: landlord,
                error,
                has_loaded,
                find
            }"
        >
            <template v-if="!has_loaded || error">
                <base-loading
                    :error="error"
                    :retry="find"
                    class="py-6"
                />

                <error-modal
                    v-if="error"
                    :error="error"
                />
            </template>

            <div
                v-else
                class="px-4 py-6 border-b text-grey-darker sm:px-6"
            >
                <base-alert
                    v-if="landlord.account.number_of_verification_attempts"
                    level="danger"
                >
                    <template slot="heading">Repeat verification attempts.</template>
                    <template slot="content">
                        <p class="my-3">
                            Unfortunately, we were unable to verify your account based on the information you provided. Please check
                            the details you submitted and try again. Please check:
                        </p>

                        <ul class="mb-3 ml-5 list-disc">
                            <li>The quality of the ID photo/scan</li>
                            <li>For spelling mistakes, typos or contradictions</li>
                            <li>That the details match IDs (i.e. legal names)</li>
                        </ul>

                        <p class="mb-3">
                            Please note, since this is the {{ landlord.account.number_of_verification_attempts + 1 | ordinal }}
                            time you're submitting your account for verification, we may have already verified some of the details
                            you provided, and as a result, cannot be edited.
                        </p>

                        <p>
                            If you're having issues verifying your account, please
                            <laroute-link
                                :to="{
                                    name: 'www.contact.index'
                                }"
                                class="underline"
                            >
                                get in touch.
                            </laroute-link>
                        </p>
                    </template>
                </base-alert>

                <p class="mb-3">
                    In order to use some of Rentora's features you'll need to verify your account. This is known as a
                    <a
                        href="https://en.wikipedia.org/wiki/Know_your_customer"
                        class="text-blue"
                        target="_blank"
                        rel="noopener"
                    >
                        "Know Your Customer"
                    </a>
                     process, and is a necessary step to complete, mostly due to bank and anti-money laundering regulations.
                </p>

                <p class="mb-3">
                    For more information on this process, and a thorough guide through this verification process, please
                    read through guide that’s most applicable to you:
                </p>

                <ul>
                    <li>
                        <a
                            href="https://help.rentora.co.uk/article/25-how-do-i-verify-my-account-as-an-individual"
                            class="inline-flex items-center text-blue"
                            target="_blank"
                            rel="noopener"
                        >
                            How do I verify my account as an individual?

                            <base-svg
                                name="icon-external-window"
                                class="w-4 h-4 ml-1 fill-primary-blue fill-secondary-blue"
                            />
                        </a>
                    </li>
                    <li>
                        <a
                            href="https://help.rentora.co.uk/article/46-how-do-i-verify-my-account-as-a-business"
                            class="inline-flex items-center text-blue"
                            target="_blank"
                            rel="noopener"
                        >
                            How do I verify my account as a business?

                            <base-svg
                                name="icon-external-window"
                                class="w-4 h-4 ml-1 fill-primary-blue fill-secondary-blue"
                            />
                        </a>
                    </li>
                </ul>
            </div>

            <div class="px-4 py-3 text-right bg-grey-bg sm:px-6">
                <router-link
                    :to="{
                        name: $router.fix('dashboard.*.verification.account.edit')
                    }"
                    class="w-full btn btn-blue md:w-auto"
                >
                    Continue
                </router-link>
            </div>
        </div>
    </landlords-find>
</template>

<script>
    import LandlordsFind from '../../../../../components/landlords-find'

    export default {
        components: {
            LandlordsFind
        }
    }
</script>
